import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"วีซ่าท่องเที่ยว — Tourist Visa สำหรับคนไทยไปต่างประเทศ","metaTitle":"บริการยื่นวีซ่าท่องเที่ยว — Schengen UK USA Australia Japan | NYC","metaDesc":"รับยื่นวีซ่าท่องเที่ยว Schengen (26 ปท.), UK, USA B1/B2, Australia 600, Canada TRV, Japan 15/30 วัน แพ็คเกจครบตั้งแต่จองสถานทูตถึงเทรน mock interview"},"en":{"h1":"Tourist Visa Services — Thai Nationals to 40+ Countries","metaTitle":"Tourist Visa Services Thailand — Schengen, UK, USA, Australia | NYC","metaDesc":"Full-service tourist visa: Schengen (26 countries), UK Standard Visitor, USA B1/B2, Canada TRV, Australia 600, Japan 15/30-day.."}} as const;

export const Route = createFileRoute("/en/visa/tourist")({
  head: () => {
    const url = `${SEO_SITE}/en/visa/tourist`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/visa/tourist", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/visa/tourist", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/visa/tourist", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/visa/tourist", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/visa/tourist", "/en/visa/tourist")],
    };
  },
  component: () => <SubServicePage slug="visa/tourist" locale="en" />,
});
